/**
 * Timeline Group Helper Utilities
 * Functions for creating and managing timeline user groups
 */

import { UserData, UserGroup } from './types';

interface ColumnDisplay {
    userId?: boolean;
    email?: boolean;
}

/**
 * Creates a user group object for the timeline with formatted HTML label
 * @param userData - The user data containing user information
 * @param columnDisplay - Configuration for which columns to display
 * @param groupBy - The grouping strategy ('TEAMS' or 'NONE')
 * @returns A formatted user group object for Vis.js Timeline
 */
export const createUserGroup = (
    userData: UserData,
    columnDisplay: ColumnDisplay,
    groupBy: string
): UserGroup => {
    const displayName = userData.user.name || userData.user.email;

    let labelParts = `<div class="user-label">
      <div class="user-name">${displayName}</div>`;

    if (columnDisplay.email) {
        labelParts += `
      <div class="user-email">${userData.user.email}</div>`;
    }

    if (columnDisplay.userId) {
        labelParts += `
      <div class="user-id">Employee ID: ${userData.user.employeeId}</div>`;
    }

    labelParts += `
    </div>`;

    const baseId = `user-${userData.user.id}`;

    // Single group row containing the user label. Shifts and tasks will be placed into this group's row.
    const labelGroup: UserGroup = {
        id: baseId,
        content: labelParts,
        value: userData.user.id,
        ...(groupBy === 'TEAMS' && { treeLevel: 1 })
    };

    return labelGroup;
};
